import * as types from '../mutation-types'

const state = {
  currentProgress: 0,
  modalUplodErrStatus: false,
  errorData: {}
}

const getters = {
  csvUploadProgress: state => state.currentProgress,
  getModalUplodErrStatus: state => state.modalUplodErrStatus,
  getErrorData: state => state.errorData
}

const actions = {
  async uploadFile ({ commit }, { method, file, url, headers, isShowErrorMessage = false }) {
    try {
      console.log('action uploadFile')
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios[method](url, file, {headers})
      // commit(types.SET_CSV_FILE_UPLOAD_PROGRESS, 0)
      if (response.status === 204) {
        commit(types.CREATE_SUCCESS_MESSAGE, 'File was successfully uploaded!')
      } else {
        console.log('err')
        commit(types.CREATE_ERROR_MESSAGE, 'Error while uploading file')
      }
      commit(types.SET_VALIDATION_ERROR_MESSAGE, {})
      commit(types.SET_STATUS_VALIDATION_ERROR_MESSAGE, false)
      return response
    } catch (err) {
      if (isShowErrorMessage) {
        commit(types.SET_VALIDATION_ERROR_MESSAGE, err.response.data)
        commit(types.SET_STATUS_VALIDATION_ERROR_MESSAGE, true)
      }
      commit(types.CREATE_ERROR_MESSAGE, 'Error while uploading file')
      // commit(types.SET_CSV_FILE_UPLOAD_PROGRESS, 0)
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_CSV_FILE_UPLOAD_PROGRESS] (state, progress) {
    state.currentProgress = progress
  },
  [types.SET_VALIDATION_ERROR_MESSAGE] (state, response) {
    state.errorData = response
  },
  [types.SET_STATUS_VALIDATION_ERROR_MESSAGE] (status) {
    state.modalUplodErrStatus = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/upload.js